import * as React from 'react'
import classNames from 'classnames'

import type { Image } from 'types'
import imgSizes from 'ui-component-library/utils/imgSizes'
import NumericList from './NumericList'
import { InlineImage } from 'content-components/_Primatives/Images'
import style from './style.scss'

type Props = {
  className?: string
  image: Image
  imageSize?: 'small' | 'medium' | 'large'
  isGradient?: boolean
  textItems: string[]
  headlineText: string
  kickerText: string
}

function NumericListPromo(props: Props) {
  const {
    className,
    image,
    imageSize = 'large',
    isGradient = true,
    textItems,
    headlineText,
    kickerText,
  } = props
  const sizes = imgSizes(400, 1000, 700)

  return (
    <div className={classNames(style.wrapper, className)}>
      <>
        <InlineImage
          className={classNames(style.image, style[imageSize])}
          gradient={isGradient}
          image={image}
          sizes={sizes}
        />
        <NumericList
          textItems={textItems}
          kickerText={kickerText}
          headlineText={headlineText}
        />
      </>
    </div>
  )
}

export default NumericListPromo
